(function(angular, schoolwork12) {
    'use strict';
    
    angular.module(schoolwork12.app.student.name)
        .controller(schoolwork12.app.studentview.controllers.studentBySubjectView, 
        ['$rootScope', '$scope', '$http', '$state',
        schoolwork12.app.auth.services.authentication,
        schoolwork12.app.common.services.utilService,
                function($rootScope, $scope, $http, $state, authentication, utilService) {
                console.info('calling student grad plan Controller- by Subject View for a Student:......');
                    
	                $scope.bySubjectView = true;
	                $scope.stuGradPlanBySubSuccess = false;
	                $scope.isStuGradPlanSubSpinnerActive = true;
	                
                    $scope.stuGradPlanBySubjectAccordions = { creditSummary: true, notCounted: true, addRequirements: true, creTracking: true, opened: true };

                    $scope.initializeSubjectView = function(){
                    	console.info('initializeSubjectView');
                        if(!$scope.yearViewClicked || $scope.savePlanSuccess){
                             var defaultStuId = $scope.hasLCRole ? $rootScope.selStuId : authentication.getCurrentUser().studentId;
                        	 $scope.getStudentGradPlanBySubject(defaultStuId);
                        } 
                    }
                     
                    //invoke by subject service 
                    $rootScope.getStudentGradPlanBySubject = function(customStuId){
                        $http({
                            url: schoolwork12.app.student.endpoints.studentEdit + customStuId + '/gradplanBySubject/school/' + authentication.getCurrentUser().schoolId,  
                            method : "GET",
                            headers : {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                    }
                        }).then(function(response){                        
                            console.info("Viewing student graduation plan by Subject");
                            $scope.isStuGradPlanSubSpinnerActive = false;
                            if(!(angular.isDefined(response.data.stuGradPlanBySubject)))
                            	{
                            	$scope.stuGradPlanBySubSuccess = false;
                            	}
                            else{
                            	 $scope.stuGradPlanBySubSuccess = true;
                            	 $scope.stuGPBySub = response.data.stuGradPlanBySubject;
                            	 $scope.buildSubjectView();
                            }
                            // $scope.$parent.stuGPBySubData = true;
                            // $scope.stuGPBySubData = true;

                        }, function(error){
                            console.info('Error in viewing student graduation plan by Subject...'.concat(angular.toJson(error)));
                            $scope.stuGradPlanBySubSuccess = false;
                            $scope.isStuGradPlanSubSpinnerActive = false;
                            $scope.getGradSubErrorOccurred = true;
                            $scope.getGradSubErrorMesg = "";
                            if (error.status == 400) {
                                $scope.stuGradPlanSuccess = false;
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.getGradSubErrorMesg = $scope.getGradSubErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.getGradSubErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }    
                        })
                    }

                    $scope.buildSubjectView = function(){
                        if(!(angular.isDefined($scope.stuGPBySub.totalCreditsEarnedForSubjectsNotOnDiploma)))
                            $scope.stuGPBySub.totalCreditsEarnedForSubjectsNotOnDiploma='--';
                        if(!(angular.isDefined($scope.stuGPBySub.totalCreditsInProgressForSubjectsNotOnDiploma)))
                            $scope.stuGPBySub.totalCreditsInProgressForSubjectsNotOnDiploma='--';
                        if(!(angular.isDefined($scope.stuGPBySub.totalCreditsNotStartedForSubjectsNotOnDiploma)))
                            $scope.stuGPBySub.totalCreditsNotStartedForSubjectsNotOnDiploma='--';
                     
                        // build subjectsList
                        $scope.subjectList = [];
                        angular.forEach($scope.stuGPBySub.subjectsDetails, function(subject){
                            subject.subjectName = $scope.subjectNameFromMap(subject.schoolSubjectId, subject.k12SubjectId);
                            subject.open = true;

                            subject.creditsEarned = angular.isDefined(subject.creditsEarned) ? subject.creditsEarned : 0;
                            subject.creditsRequired = angular.isDefined(subject.creditsRequired) ? subject.creditsRequired : 0;
                            subject.creditsInprogress = angular.isDefined(subject.creditsInprogress) ? subject.creditsInprogress : 0;
                            subject.creditsNotStarted = angular.isDefined(subject.creditsNotStarted) ? subject.creditsNotStarted : 0;
                            subject.creditsNotCounted = angular.isDefined(subject.creditsNotCounted) ? subject.creditsNotCounted : 0;
                    
                            if(angular.isDefined(subject.subSubjects)){
                                angular.forEach(subject.subSubjects, function(subSubject){
                                    subSubject.subjectName = $scope.subjectNameFromMap(subSubject.schoolSubjectId,subSubject.k12SubjectId); 
                                    subSubject.creditsEarned = angular.isDefined(subSubject.creditsEarned) ? subSubject.creditsEarned : 0;
                                    subSubject.creditsRequired = angular.isDefined(subSubject.creditsRequired) ? subSubject.creditsRequired : 0;
                                    subSubject.creditsInprogress = angular.isDefined(subSubject.creditsInprogress) ? subSubject.creditsInprogress : 0;
                                    subSubject.creditsNotStarted = angular.isDefined(subSubject.creditsNotStarted) ? subSubject.creditsNotStarted : 0;
                                    subSubject.creditsNotCounted = angular.isDefined(subSubject.creditsNotCounted) ? subSubject.creditsNotCounted : 0;
                                    angular.forEach(subSubject.stuGPCourse, function(course){
                                       course.courseName = $scope.courseDisplay(course); 
                                       course.credits = $scope.creditsDisplay(course);
                                       getGradefromStatus(course);
                                       course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                       course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                    });
                                });
                            } else {
                                angular.forEach(subject.stuGPCourse, function(course){
                                    course.courseName = $scope.courseDisplay(course); 
                                    course.credits = $scope.creditsDisplay(course);
                                    getGradefromStatus(course);
                                    course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                    course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                }); 
                            }
                            $scope.subjectList.push(subject);
                        });
                        //Sort the hierarchial structure for subjectlist
                        // For each subject in subject list 
                        angular.forEach($scope.subjectList, function(subject){                            
                            // If subsubjects are present                           
                            if(angular.isDefined(subject.subSubjects)){                                
                                angular.forEach(subject.subSubjects , function(subSubject){
                                   //sort courses for each sub-subject
                                   if(angular.isDefined(subSubject.stuGPCourse && subSubject.stuGPCourse.length > 1)){
                                        subSubject.stuGPCourse.sort(courseSort);    
                                   } 
                                });
                                //sort sub-subjects alphabetically in each subject
                                subject.subSubjects.sort(sortSubject);
                            // If no sub-subjects are present and subject has courses                                
                            } else if(angular.isDefined(subject.stuGPCourse)){
                                //sort courses in subject
                                subject.stuGPCourse.sort(courseSort);
                            }                           
                        });
                        // sort list of subjects alphabetically in subject list
                        // sample using _.js
                        $scope.subjectList = _.sortBy($scope.subjectList, 'subjectName');

                        // build subjectsNotOnDiploma
                        $scope.subjectsNotOnDiploma = [];
                        angular.forEach($scope.stuGPBySub.subjectsNotOnDiploma, function(subject){
                            var subjectName = $scope.subjectNameFromMap(subject.schoolSubjectId, subject.k12SubjectId);
                            angular.forEach(subject.stuGPCourse, function(course){
                                var subcourse = {subjectName : subjectName};
                                course.courseName = $scope.courseDisplay(course);
                                course.credits = $scope.creditsDisplay(course);
                                getGradefromStatus(course);
                                course.showDagger = course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                                course.showAstrick = course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                                angular.extend(subcourse, course);
                                $scope.subjectsNotOnDiploma.push(subcourse);
                            });
                        });
                        
                        $scope.subjectsNotOnDiploma.sort(sortSubject);
                    }

                    //initialize controller and load subject view
                    $scope.initializeSubjectView();
            
                    var getGradefromStatus = function(course){
                        if(course.completionStatusId==0)
                            course.gradeMark = 'Not Started';
                        if(course.completionStatusId==1)
                            course.gradeMark = 'In Progress';
                        if(course.completionStatusId==4)
                            course.gradeMark = 'F';

                        return course.gradeMark;
                    }

                    var sortSubject = function(a, b) {
                        if((a.subjectName == "" || b.subjectName == "") && !(a.subjectName == ""&&b.subjectName == "")){
                            if(a.subjectName=="")
                                return 1;
                            else 
                                return -1;
                        }
                        if(a.subjectName == b.subjectName){
                            return courseSort(a,b);
                        }
                        if(a.subjectName > b.subjectName){
                            return 1;
                        }
                        if(a.subjectName < b.subjectName){
                            return -1;
                        }
                    }
                    
                    var courseSort = function(a, b) {                       
                        if(a.courseName == "Not Specified" || b.courseName == "Not Specified"){                                                   if(a.courseName == "Not Specified") return 1;
                            else return -1;
                        }
                        else{
                            return a.courseName > b.courseName ? 1 : -1;
                        }                        
                    }

            }
        ]);   
}(angular, schoolwork12));
